// eslint-disable-next-line import/prefer-default-export
export const RESET_STATE = 'RESET_STATE';
export const RESET_NOT_PERSISTED = 'RESET_NOT_PERSISTED';
export const SET_CRITERE = 'SET_CRITERE';
export const RESET_CRITERE = 'RESET_CRITERE';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
